/* eslint-disable no-param-reassign */
import { Core } from 'cytoscape';

export function applyGrabState(cy: Core, container: HTMLElement) {
  let overANodeOrEdge = false;

  cy.on('mousedown', () => {
    if (!overANodeOrEdge) {
      container.style.cursor = 'grabbing';
    }
  });
  cy.on('mouseup', () => {
    container.style.cursor = 'default';
  });

  cy.nodes().on('mouseover', () => {
    overANodeOrEdge = true;
  });
  cy.nodes().on('mouseout', () => {
    overANodeOrEdge = false;
  });
  cy.edges().on('mouseover', () => {
    overANodeOrEdge = true;
  });
  cy.edges().on('mouseout', () => {
    overANodeOrEdge = false;
  });
}
